//noinspection JSFileReferences
import index from './experiences/index.js';

index.init();